import { Box, Typography, Button, Link } from '@mui/material'
import { useNavigate, Link as RouterLink } from 'react-router-dom'

import { ReactComponent as AirImpactLogo } from '../../assets/img/logo/airimpact-logo-colorful-with-text.svg'
import Illustration from '../../assets/something-went-wrong.png'
import { ReactComponent as ArrowBack } from '../../icons/arrow-back.svg'

interface IEmailLink {
  to: string
  subject: string
  children: string
}

function EmailLink(props: IEmailLink) {
  const { to, subject, children } = props

  const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}`

  return (
    <Link component={RouterLink} to={mailtoLink} target="_blank" sx={{ fontWeight: 500, textDecoration: 'none' }}>
      {children}
    </Link>
  )
}

export default function () {
  const navigate = useNavigate()

  return (
    <Box width="100vw" height="100vh" display="flex" p="40px 60px" bgcolor="white" flexDirection="column">
      <AirImpactLogo />
      <Box m="auto" display="flex" flexDirection="column">
        <img src={Illustration} alt="AirImpact" style={{ width: '680px', height: '450px' }} />
        <Typography variant="h1" align="center" mt={2.5} color="primary.800" textAlign="center">
          Oops! Something went wrong
        </Typography>
        <Typography variant="body1" align="center" mt={1} color="grey.500" textAlign="center" mb={3.5}>
          If you’re experience a critical issue, please&nbsp;
          <EmailLink to="support@airimpact.co" subject="Support request">
            Contact support
          </EmailLink>
          .<br /> In the meantime, try again.
        </Typography>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{
            width: 'fit-content',
            ml: 'auto',
            mr: 'auto',
          }}
        >
          Go back
        </Button>
      </Box>
    </Box>
  )
}
